import { render, staticRenderFns } from "./essay.vue?vue&type=template&id=47e01204"
import script from "./essay.vue?vue&type=script&lang=js"
export * from "./essay.vue?vue&type=script&lang=js"
import style0 from "./essay.vue?vue&type=style&index=0&id=47e01204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports